import React from 'react';
import AppRoutes from './routes/AppRoutes';

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
